import normalizeDevice from '../utils/normalize-device';
import getAuthors from '../utils/get-authors';

// pulse has 'medium' as 'channel' in schema
const utmToPulse = (utm) => {
    const { medium, ...rest } = utm;

    const converted = {
        ...rest,
    };

    if (medium) {
        converted.channel = medium;
    }

    return converted;
};

// get name of each parent section
const getSectionNames = (section) => {
    const sectionNames = [];
    let currentSection = section;
    while (currentSection) {
        sectionNames.unshift(currentSection.statisticsName);
        currentSection = currentSection.parent;
    }

    return sectionNames;
};

// transforms state from screens into tracking params
export default function clientParams({
    config = {},
    state = {},
    layout,
    utm = {},
    location = {},
} = {}) {
    const {
        article,
        collectionArticles,
        plussArticles,
        spid = {},
        device,
        paywallType = 'spid',
    } = state;

    const { clientAgreementAccepted, defaultAgreementAccepted } = spid;
    const userId = clientAgreementAccepted && defaultAgreementAccepted ? spid.userId : null;
    const { baseUrl, tracking: { engage: { enableOverlay = false } = {} } = {} } = config;

    if (!baseUrl || !device) {
        return {};
    }

    const customPulseData = utmToPulse(utm);
    let content = {};
    let url;
    let type;

    if (article && article.id) {
        const {
            id = '',
            title = '',
            section = {},
            tags,
            changes = {},
            authors,
            clientProperties = {},
            customProperties: { vg_paywall: isSubscription } = {},
        } = article;

        if (!id || !title) {
            return {};
        }

        const {
            statisticsName = '',
            parent: { statisticsName: parentSection = '' } = {},
            title: sectionTitle = '',
        } = section;

        const group = sectionTitle;
        const isPaid = isSubscription && layout === 'promo';

        customPulseData.accessLevel = isSubscription ? 'Paid' : 'Free';

        if (isPaid) {
            customPulseData.paywallType = paywallType;
        }

        type = isPaid ? 'SalesPoster' : 'Article';
        url = `${baseUrl}/i/${id}`; // short url

        content = {
            id,
            title: title.value,
            categories: [`${parentSection}>${statisticsName}`],
            group,
            section,
            tags,
            productTag: isSubscription ? 'vgpluss' : 'vg',
            published: changes.published,
            updated: changes.updated,
            authors: getAuthors(authors),
            wordcount: clientProperties.wordCount,
        };
    } else if (collectionArticles && collectionArticles.collection.length) {
        const { collection: articles, meta } = collectionArticles;
        const { section, story, tag } = meta;
        customPulseData.numItems = articles ? articles.length : 0;

        type = 'Listing';
        url = baseUrl + location.pathname;
        if (section) {
            url = section.url;
            const sectionNames = getSectionNames(section);
            const id = `/${sectionNames.join('/')}`;
            const category = sectionNames.join('>');

            content = {
                id,
                title: section.statisticsName,
                category,
                categories: [category],
            };
        } else if (tag) {
            content = {
                id: tag.id,
                title: tag.title,
            };
        } else if (story) {
            content = {
                id: story.id,
                title: story.title,
            };
        }
    } else if (plussArticles && plussArticles.pluss.length) {
        // vg.no/pluss
        type = 'Listing';
        url = baseUrl + location.pathname;
        content = {
            id: '/pluss',
            title: 'VG+ Landingsside',
            productTag: 'vgpluss',
        };
    }

    if (!url || !type) {
        // eslint-disable-next-line no-console
        console.warn(new Error('Missing important tracking variables'));
    }

    const trackingOpt = {
        site: 'VG',
        device: normalizeDevice(device),
        type,
        url,
        content,
        config: config.tracking,
        enableOverlay,
        custom: {
            pulse: customPulseData,
        },
    };

    if (userId) {
        trackingOpt.userId = userId;
    }

    return trackingOpt;
}



/** WEBPACK FOOTER **
 ** ./src/tracking/client-params.js
 **/